import styled from 'styled-components'

import mediaQueries from 'components/media-queries'

export const SwapFieldsContainer = styled.div.attrs(() => ({
  className: 'swap-fields'
}))`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 30px;
  ${mediaQueries.tablet`
    ${({ rotateInTablet }) =>
      rotateInTablet &&
      `
    transform: rotate(90deg);
    margin-right: 10px;
    padding-top: 6px;
  `};
  `};
  ${mediaQueries.mobile`
    transform: rotate(90deg);
    margin-right: 10px;
    padding-top: 6px;
  `};
`
